/**
 * Client-side defaults when org flags are missing or still loading.
 * Backend defaultFlags also seed these keys as true for new orgs.
 */
export const FEATURE_FLAG_DEFAULTS = {
  'api.ai.tools.invoke': true,
  'api.ai.navigationContext': true,
  'api.ai.ragContext': true,
  'ui.pages.Dashboard': true,
  'ui.pages.Streams': true,
  'ui.pages.Projects': true,
  'ui.pages.Repositories': true,
  'ui.pages.Members': true,
  'ui.pages.Profile': true,
  'ui.pages.Notifications': true,
  'ui.pages.surveyHub.sets': true,
  'ui.pages.surveyHub.questions': true,
  'ui.pages.surveyHub.emails': true,
  'ui.pages.surveyHub.sessions': true,
  'ui.auth.googleLogin': true,
  'ui.auth.passwordLogin': true,
  'ui.pages.reviewPortal': true,
  'ui.pages.StreamEmpowermentSessions': true,
  'ui.pages.SesQuestionEdit': true,
};

export function resolveFeatureFlagDefault(key, explicitDefault = false) {
  if (typeof key !== 'string') return explicitDefault ?? false;
  if (Object.prototype.hasOwnProperty.call(FEATURE_FLAG_DEFAULTS, key)) {
    return FEATURE_FLAG_DEFAULTS[key];
  }
  return explicitDefault ?? false;
}
